// extracted by mini-css-extract-plugin
export default {"stoneExample":"style_stoneExample__Dwhqt","preview":"style_preview__o-oCz"};